import { Injectable, Injector } from "@angular/core";
import { Http, Response } from "@angular/http";
import { ApiService } from "../base-service/api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class PhotoInterfaceService extends ApiService<any, any, any> {
    urlPath: string = 'campaignItems/search/images';

    constructor(Http: HttpClient, Injector: Injector, private http: Http) {
        super(Http, Injector);
    }

   
}


@Injectable()
export class PhotoInterfaceAllImagesService extends ApiService<any, any, any> {
    urlPath: string = 'images';

    constructor(Http: HttpClient, Injector: Injector, private http: Http) {
        super(Http, Injector);
    }
}
